import { useEffect, useRef, useState } from 'react';
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { collectionAmountAction, getAllAgentForDropDownAction, organizationAction } from '../../../Redux/Action/MemberAction';
import Auth from '../../../Utilities/Auth';

function CollectionHistorySearchHandler({ preFilteredData = [], setFilteredDataState }) {
    //ref
    const btnRef = useRef()
    // Hook
    const dispatch = useDispatch()
    // hook form
    const { register, handleSubmit, getValues, reset, setValue, formState: { errors } } = useForm();

    //state
    const [organizationList, setOrganizationList] = useState([])
    const [getCollectionAmount, setGetCollectionAmount] = useState([])
    const [agentIds, setAgentIds] = useState([])
    const [reloadThisComponent, setReloadThisComponent] = useState(false)

    const user_detail = JSON.parse(Auth.header().userdetail)

    // making active years lifecycle
    useEffect(() => {
        const payload = {
            setOrganizationList,
            setGetCollectionAmount,
            setAgentIds
        }

        dispatch(organizationAction(payload))
        dispatch(collectionAmountAction(payload))
        dispatch(getAllAgentForDropDownAction(payload))

    }, [])

    // data filtering
    useEffect(() => {
        const agent_id = getValues("agent_id") || ""
        const organization_id = getValues("organization_id") || ""
        const collection_amount = getValues("collection_amount") || ""
        const search_key = getValues("search_key") || ""

        const filteredData = preFilteredData.filter(singleData => {
            if (agent_id && singleData.collection_user_id != agent_id) return false
            if (organization_id && singleData.organization_id != organization_id) return false
            if (collection_amount && singleData.collection_amount != collection_amount) return false

            if (search_key) {
                const key = search_key.toLowerCase()

                const nameMatch = (singleData.member.member_name || "")
                    .toLowerCase()
                    .includes(key)

                const villageMatch = (singleData.member.village || "")
                    .toLowerCase()
                    .includes(key)

                const phoneMatch = (singleData.member.mobile || "")
                    .toLowerCase()
                    .includes(key)

                if (!nameMatch && !villageMatch && !phoneMatch) return false
            }

            return true
        })

        setFilteredDataState(filteredData)

    }, [reloadThisComponent, preFilteredData])

    const onSubmit = data => {
        setReloadThisComponent(prev => !prev)
    }
    return (
        <>
            {user_detail?.is_admin == "1" && <form onChange={(e) => { setReloadThisComponent(prev => !prev) }} onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col md={3} sm={12}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <div style={{ position: "relative" }}>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Donor Name, Phone & Village "
                                    {...register("search_key", {
                                        required: false,
                                    })}

                                // onBlur={()=>{}}
                                />
                                {/* <RxCross2 onClick={e => {
                                    setValue("agent_id", "")
                                    // document.getElementById("collectionSubmitButton").click()
                                }} style={{ position: "absolute", top: "9px", right: "10px", fontSize: "18px", cursor: "pointer" }} className=" text-danger" /> */}
                            </div>
                            {/* validation message*/}
                            {errors.agent_id && <span className="text-danger">
                                {errors.agent_id.type === "required" && "Please Give Collector Id"}
                                {errors.agent_id.type === "pattern" && "Please Give Valid Collector Id"}
                            </span>}
                        </Form.Group>
                    </Col>


                    <Col md={2} sm={12}>
                        <Form.Group className="mb-3 select78" controlId="formBasicEmail">
                            <Form.Select aria-label="Default select example" {...register("agent_id",)}>
                                <option value="">Select Collector I'D</option>
                                {agentIds.map((singleAgent, index) => (
                                    <option key={index} value={singleAgent.id}>I'D: {singleAgent.id}</option>
                                    // <option key={index} value={singleAgent.id}>I'D: {singleAgent.id} {singleAgent.full_name}</option>
                                ))}

                            </Form.Select>
                        </Form.Group>
                    </Col>


                    <Col md={2} sm={12}>
                        <Form.Group className="mb-3 select78" controlId="formBasicEmail">
                            <Form.Select aria-label="Default select example" {...register("organization_id",)}>
                                <option value="">Select Organization</option>
                                {organizationList.map((singleOrg, index) => (
                                    <option key={index} value={singleOrg.id}>{singleOrg.organization_name}</option>
                                ))}

                            </Form.Select>


                        </Form.Group>
                    </Col>

                    <Col md={2} sm={12}>
                        <Form.Group className="mb-3 select78" controlId="formBasicEmail">
                            <Form.Select aria-label="Default select example" {...register("collection_amount")}>
                                <option value="">Select Amount</option>
                                {getCollectionAmount.map((singleOrg, index) => (
                                    <option key={index} value={singleOrg.collection_amount}>{singleOrg.collection_amount}</option>
                                ))}

                            </Form.Select>


                        </Form.Group>
                    </Col>
                    <Col md={2} sm={12}>
                        <Button id='collectionSubmitButton' ref={btnRef} variant="primary" type="submit" className="submit">
                            Search
                        </Button>
                    </Col>
                </Row>
            </form>}
        </>
    );
}

export default CollectionHistorySearchHandler;